import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useLookupsContext } from "hooks/useContext";
import useNotify from "hooks/useNotify";
import { actions } from "store/actions";
import profileApi from "api/profile";
import { scrollIntoView } from "utils/helper";

function useAvailability() {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.userDetails || {});
  const [isLoading, setIsLoading] = useState(false);

  const { timezones } = useLookupsContext(true);
  const { notifyError, notifySuccess } = useNotify();

  const onEditSave = async (values) => {
    try {
      setIsLoading(true);

      const { availability, timezone: timezoneId } = values;

      const payload = {
        timezoneId,
        availability: {
          days: availability.days || [],
          time: {
            from: availability.time?.from || "",
            to: availability.time?.to || "",
          },
        },
      };
      if (userDetails?.agencyId) {
        await profileApi.updateCompanyDetails(userDetails?.agencyId, payload);
      } else {
        await profileApi.updatePersonalDetailsApi(
          userDetails?.vendorId,
          payload
        );
      }

      const updatedData = {
        ...userDetails,
        availability: payload.availability,
        timezone: timezones.find((elem) => elem.id === values.timezone),
      };
      dispatch(actions.setUserDetails(updatedData));

      notifySuccess(t("availabilityUpdated"));
      scrollIntoView("availabilityScrollId");
    } catch (err) {
      console.error(err);
      notifyError(err?.data?.error ?? err?.message ?? "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  return {
    onEditSave,
    isLoading,
  };
}

export default useAvailability;
